import React from 'react';
import { DollarSign } from 'lucide-react';
import { formatCurrency } from '../../utils/formatting';

export default function OrderTotals({ extractedData, selectedItems }) {
  // Compute total from line items: resolution values take priority, then PO extracted values
  const computedTotal = (selectedItems || []).reduce((sum, item) => {
    if (item.resolution) {
      return sum + (item.resolution.quantity * item.resolution.unitPrice);
    }
    const qty = item.poQuantity || 0;
    return sum + (item.extTotal || (qty * (item.extUnitPrice || 0)));
  }, 0);

  return (
    <div className="bg-slate-800 rounded-xl p-4">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider flex items-center gap-2">
          <DollarSign className="w-3 h-3" />
          Totals
        </h3>
        {extractedData?.total != null && (
          <span className="text-xs text-slate-500">
            Extracted PO Total: {formatCurrency(extractedData.total)}
          </span>
        )}
      </div>
      <div className="space-y-2">
        {extractedData?.tax > 0 && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-slate-400">Tax</span>
            <span className="text-white">{formatCurrency(extractedData?.tax)}</span>
          </div>
        )}
        <div className="flex items-center justify-between text-lg font-bold pt-2 border-t border-slate-700">
          <span className="text-slate-300">Total</span>
          <span className="text-white">{formatCurrency(computedTotal + (extractedData?.tax || 0))}</span>
        </div>
      </div>
    </div>
  );
}
